var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app",
      class: {
        "full-screen": _vm.fullScreen,
        "width-screen": _vm.menus.length == 0
      },
      attrs: { id: "app" }
    },
    [
      _c("nav-header", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.fullScreen,
            expression: "!fullScreen"
          }
        ]
      }),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar" }, [
        _c(
          "div",
          { staticClass: "sidebar-nav" },
          [
            _c(
              "el-menu",
              {
                attrs: {
                  "default-active": _vm.activeIndex,
                  router: "",
                  "default-opends": _vm.opends
                },
                on: { select: _vm.handelMenu }
              },
              _vm._l(_vm.menus, function(item) {
                return _c(
                  "div",
                  { key: item.id },
                  [
                    !item.children
                      ? _c(
                          "el-menu-item",
                          { attrs: { index: item.path, data: item.path } },
                          [
                            item.iconCls
                              ? _c("i", { class: item.iconCls })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "span",
                              { attrs: { slot: "title" }, slot: "title" },
                              [_vm._v(_vm._s(item.name))]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    item.children
                      ? _c(
                          "el-submenu",
                          { attrs: { index: item.path, data: item.path } },
                          [
                            _c("template", { slot: "title" }, [
                              item.iconCls
                                ? _c("i", { class: item.iconCls })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(item.name))])
                            ]),
                            _vm._v(" "),
                            _vm._l(item.children, function(sItem) {
                              return _c(
                                "el-menu-item",
                                {
                                  key: sItem.id,
                                  attrs: { index: sItem.path, data: item.path }
                                },
                                [
                                  sItem.iconCls
                                    ? _c("i", { class: sItem.iconCls })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { attrs: { slot: "title" }, slot: "title" },
                                    [_vm._v(_vm._s(sItem.name))]
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e()
                  ],
                  1
                )
              }),
              0
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "main-content" }, [_c("router-view")], 1),
      _vm._v(" "),
      _c("nav-footer", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.fullScreen,
            expression: "!fullScreen"
          }
        ]
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "关注微信公众号",
            visible: _vm.$root.wxDialogVisible,
            width: "600px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.$root, "wxDialogVisible", $event)
            }
          }
        },
        [
          _c("div", { staticClass: "codes" }, [
            _c("div", [
              _c("p", { staticClass: "font-15" }, [_vm._v("扫码关注公众号")]),
              _vm._v(" "),
              _c("img", {
                staticStyle: { height: "200px" },
                attrs: { src: "/static/img/wx_code.jpg", alt: "" }
              })
            ]),
            _vm._v(" "),
            !_vm.$root.tenantInfo.isLeader
              ? _c(
                  "div",
                  [
                    _c("p", { staticClass: "font-15" }, [
                      _vm._v("手机端二维码")
                    ]),
                    _vm._v(" "),
                    _c("qr-code", {
                      staticStyle: { "margin-top": "15px" },
                      attrs: {
                        text:
                          this.envConfig.mobile +
                          "#/client?tenantCode=" +
                          _vm.$root.tenantInfo.code,
                        size: 340,
                        logo: _vm.$root.tenantInfo.logoUrl,
                        type: ""
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-098c90e9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-098c90e9","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pc/App.vue
// module id = 513
// module chunks = 14